
import '../styles/AboutComponent.css';
import Partners from './PartnersComponent';

const AboutComponent = ({aboutContent}) => {
  return (
      // <div className="container-fluid text-light py-5" id="about" style={{marginTop: 60}}>
      <div className="container">
          <div id="intro-text">
              <div className="row text-center">
                  <h1 className="about-title">{aboutContent.title}</h1>
              </div>
              <div className="row text-center">
                  <h2 className="about-text">{aboutContent.text}</h2>
              </div>
              {/*<div className="row text-center" style={{marginTop: 60, display: 'flex', justifyContent: 'center'}}>*/}
              {/*    <EmailForm/>*/}
              {/*</div>*/}
              <div className="row" style={{marginTop: 90}}>
                  <Partners/>
              </div>
          </div>

      </div>
  );
};

export default AboutComponent;
